import {
    CHATBOT_CONVERSATION_MESSAGE__FAILURE,
    CHATBOT_CONVERSATION_MESSAGE__REQUEST,
    CHATBOT_CONVERSATION_MESSAGE__SUCCESS,
    CHATBOT_MESSAGE_FEEDBACK_FAILURE,
    CHATBOT_MESSAGE_FEEDBACK_LIKE_SUCCESS,
    CHATBOT_MESSAGE_FEEDBACK_REQUEST,
    CHATBOT_MESSAGE_FEEDBACK_UNLIKE_SUCCESS,
    NEW_CHATBOT_MESSAGE_FAILURE,
    NEW_CHATBOT_MESSAGE_REQUEST,
    NEW_CHATBOT_MESSAGE_SUCCESS,
    RESET_CHATBOT,
    RESET_INTERACTION_FORM,
    UPDATE_SINGLE_CHATBOT_MESSAGE_SUCCESS,
} from "./constants";
import { getBaseUrl, ChatBotUrls } from '../../utils/links';
import { onRequest, onSuccess, onError, getResponseData } from "../../utils/helper";
import Axios from "axios";
const CancelToken = Axios.CancelToken;

export let getConversationMessageCancelToken = undefined;
export function getConversationMessage(token, chatBotUrl) {
    return dispatch => {
        dispatch(onSuccess(CHATBOT_CONVERSATION_MESSAGE__REQUEST));
        if (getConversationMessageCancelToken) getConversationMessageCancelToken();
        let url = `${chatBotUrl ? `${chatBotUrl}/api/` : getBaseUrl()}${ChatBotUrls.conversationItem}`,
            options = {
                url,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                cancelToken: new CancelToken((c) => getConversationMessageCancelToken = c)
            };
        return Axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    dispatch(onSuccess(CHATBOT_CONVERSATION_MESSAGE__SUCCESS, response.data.data));
                }
                return response.data;
            })
            .catch(err => {
                dispatch(onError(CHATBOT_CONVERSATION_MESSAGE__FAILURE));
            })
    }
}

export function resetChatBot() {
    return {
        type: RESET_CHATBOT
    }
}

export const updateSingleChatBotMessage = (item) => {
    return dispatch => {
        dispatch(onSuccess(UPDATE_SINGLE_CHATBOT_MESSAGE_SUCCESS, { data: item }));
    }
}

export function chatBotMessageFeedback(id, data, type, token, chatBotUrl) {
    return dispatch => {
        dispatch(onSuccess(CHATBOT_MESSAGE_FEEDBACK_REQUEST));
        let url = `${chatBotUrl ? `${chatBotUrl}/api/` : getBaseUrl()}${ChatBotUrls.feedback(id)}`,
            options = {
                method: 'PATCH',
                url,
                data,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
            };
        return Axios(options)
            .then(response => {
                let successData = getResponseData(response);
                let payload = {
                    id: id
                }
                if (successData) {
                    dispatch(onSuccess(type === "like" ?
                        CHATBOT_MESSAGE_FEEDBACK_LIKE_SUCCESS :
                        type === "submit" ? RESET_INTERACTION_FORM :
                            CHATBOT_MESSAGE_FEEDBACK_UNLIKE_SUCCESS, payload));
                }
                return response.data
            })
            .catch(err => {
                dispatch(onError(CHATBOT_MESSAGE_FEEDBACK_FAILURE));
            })
    }
}
export let chatBotSendMessageCancelToken = undefined;
export function chatBotSendMessage(data, token, message, chatBotUrl) {
    return dispatch => {
        dispatch(onRequest(NEW_CHATBOT_MESSAGE_REQUEST, { message }));
        let url = `${chatBotUrl ? `${chatBotUrl}/api/` : getBaseUrl()}${ChatBotUrls.sendMessage}`,
            options = {
                method: 'POST',
                url,
                data,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                cancelToken: new CancelToken((c) => chatBotSendMessageCancelToken = c)

            };
        return Axios(options)
            .then(response => {
                let successData = getResponseData(response);
                let payload = {
                    data: response.data.data
                }
                if (successData) {
                    dispatch(onSuccess(NEW_CHATBOT_MESSAGE_SUCCESS, payload));
                }
                return response.data
            })
            .catch(err => {
                dispatch(onError(NEW_CHATBOT_MESSAGE_FAILURE));
            })
    }
}

export function chatBotVisualizeMessage(data, token, chatBotUrl) {
    return dispatch => {
        dispatch(onRequest(NEW_CHATBOT_MESSAGE_REQUEST, { message: data.message }));
        let url = `${getBaseUrl()}${ChatBotUrls.visualizeData}`,
            options = {
                method: 'POST',
                url,
                data,
                headers: {
                    'Authorization': `Bearer ${token}`
                },
            };
        return Axios(options)
            .then(response => {
                let successData = getResponseData(response);
                if (successData) {
                    let payload = {
                        data: successData
                    }
                    dispatch(onSuccess(NEW_CHATBOT_MESSAGE_SUCCESS, payload));
                }
                return response.data
            })
            .catch(err => {
                dispatch(onError(NEW_CHATBOT_MESSAGE_FAILURE));
            })
    }
}

export function resetInteractionForm() {
    return {
        type: RESET_INTERACTION_FORM
    }
}

